import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {far} from '@fortawesome/free-regular-svg-icons';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {NotificationsModule} from '@surescripts/notifications';
import {ProductDropdownModule} from '@surescripts/product-dropdown';
import {UserProfileModule} from '@surescripts/user-profile';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NavMenuComponent} from './nav-menu/nav-menu.component';
import {ProductsComponent} from './products/products.component';
import {ConfigurationService} from './shared/services/configuration.service';
import {ProductsService} from './shared/services/products.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppHttpInterceptor } from './app.httpInterceptor';

@NgModule({
  declarations: [
    AppComponent,
    ProductsComponent,
    NavMenuComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ProductDropdownModule,
    UserProfileModule,
    NotificationsModule,
    FontAwesomeModule
  ],
  providers: [
    ProductsService,
    ConfigurationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far);
  }
}
